import script from "./FriendsTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendsTabs.vue?vue&type=script&setup=true&lang=js"

import "./FriendsTabs.vue?vue&type=style&index=0&id=03b3a5ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b3a5ba"]])

export default __exports__